export default "__VITE_ASSET__28dcc402__"